import React from 'react'

const SearchContext = new React.createContext()

export default SearchContext
